/* ===============================
   WISHLIST — LOCALSTORAGE ONLY
   =============================== */

const STORAGE_KEY = "wishlist";

/* -------------------------------
   Helpers
-------------------------------- */
function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch (e) {
    return [];
  }
}

function saveWishlist(arr) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
}

function updateHeaderBubble(count) {
  document.querySelectorAll('.wishlist_link').forEach(link => {
    const bubble = link.querySelector('.wishlist-bubble');
    if (!bubble) return;

    if (count > 0) {
      link.classList.add('active');
      bubble.classList.remove('hidden');
      bubble.innerText = count;
    } else {
      link.classList.remove('active');
      bubble.classList.add('hidden');
      bubble.innerText = '';
    }
  });
}

/* -------------------------------
   State
-------------------------------- */
let wishlistArray = getWishlist();
updateHeaderBubble(wishlistArray.length);

/* -------------------------------
   Button Logic
-------------------------------- */
function onButtonClick(button) {
  const variantId = button.dataset.var;
  const parent = button.closest(".pdp-wishlist-icon");
  const textBox = parent?.querySelector(".wishlist_text_change");

  const exists = wishlistArray.find(item => item.var === variantId);

  if (exists) {
    wishlistArray = wishlistArray.filter(item => item.var !== variantId);
    button.classList.remove('active');
    if (textBox) textBox.innerText = "Add to Wishlist";
  } else {
    wishlistArray.push({
      id: button.dataset.id,
      title: button.dataset.title,
      handle: button.dataset.handle,
      var: variantId
    });
    button.classList.add('active');
    if (textBox) textBox.innerText = "Added to Wishlist";
  }

  saveWishlist(wishlistArray);
  updateHeaderBubble(wishlistArray.length);
}

/* -------------------------------
   INIT (REUSABLE)
-------------------------------- */
function initWishlist(context = document) {
  context.querySelectorAll('.wishlist-Product').forEach(button => {
    if (button.dataset.wishlistInit) return;
    button.dataset.wishlistInit = 'true';

    const isActive = wishlistArray.find(item => item.var === button.dataset.var);
    const parent = button.closest(".pdp-wishlist-icon");
    const textBox = parent?.querySelector(".wishlist_text_change");

    if (isActive) {
      button.classList.add('active');
      if (textBox) textBox.innerText = "Added to Wishlist";
    }

    button.addEventListener('click', () => onButtonClick(button));
  });

  context.querySelectorAll(".wishlist_text_change").forEach(textBtn => {
    if (textBtn.dataset.wishlistInit) return;
    textBtn.dataset.wishlistInit = 'true';

    textBtn.addEventListener("click", () => {
      const wrapper = textBtn.closest(".pdp-wishlist-icon");
      const iconBtn = wrapper?.querySelector(".wishlist-Product");
      if (iconBtn) iconBtn.click();
    });
  });
}

/* -------------------------------
   Initial Load
-------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  initWishlist();
});

/* -------------------------------
   Shopify product-recommendations
-------------------------------- */
const recommendations = document.querySelector('product-recommendations');

if (recommendations) {
  const observer = new MutationObserver(() => {
    if (recommendations.querySelector('.wishlist-Product')) {
      initWishlist(recommendations);
      observer.disconnect(); // stop once initialized
    }
  });

  observer.observe(recommendations, {
    childList: true,
    subtree: true
  });
}